export const makeToast = (vue: any, message: string, title: string, variant: 'success' | 'danger' | 'info' | 'warning' | '') => {
    vue.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
    })
}

/**
 * Проверяет блок КБК-классификаторов: если хотя бы у одного уровня есть выбранные коды (selected.length > 0),
 * но при этом все уровни деактивированы (active = false), — бросает ошибку.
 * Это предотвращает ситуацию, когда пользователь снял все чек-боксы разрезности,
 * но остались ранее выбранные коды, которые фильтруют данные незаметно для пользователя.
 *
 * Блок без selected-кодов и без активных уровней — ошибкой не считается.
 */
export const validateClassificatorsBlock = (classificators: Array<{ key: string; selected: number[]; active: boolean }>) => {
    const hasSelected = classificators.some(it => it.selected.length > 0)
    const allInactive = classificators.every(it => !it.active)
    if (hasSelected && allInactive) {
        throw new Error('error_input_at_least_one_kbk')
    }
}
